import { render, staticRenderFns } from "./PersonContractList.vue?vue&type=template&id=213d3408&scoped=true&"
import script from "./PersonContractList.vue?vue&type=script&lang=js&"
export * from "./PersonContractList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213d3408",
  null
  
)

export default component.exports